import { uniq } from 'es-toolkit';
import React, { useMemo } from 'react';
import { Box } from '@mui/material';

import { PropertySelectField } from '@paragon/client-tools';

import { getUniqueLumbersInLumberListForActiveComponentDesign } from '../../../../../store/selectors/getUniqueLumbersInLumberList';
import { useAppSelector } from '../../../../hooks';

const renderNumberInInches = (value: number) => `${value}" (${Math.ceil(value)}x)`;

interface Props {
  readonly thickness: number | null;
  readonly setFeaturePatternTrussThickness: (thickness: number) => void;
}

export default function ComponentThicknessProperty(props: Props) {
  const lumbers = useAppSelector(getUniqueLumbersInLumberListForActiveComponentDesign);
  const possibleThicknesses = useMemo(
    () =>
      uniq(
        lumbers
          .map((lumber) => lumber.actualThickness)
          .concat(lumbers.filter((lumber) => lumber.structure === 'Sawn').map((lumber) => lumber.actualWidth)),
      ).toSorted((a, b) => a - b),
    [lumbers],
  );

  return (
    <Box sx={{ display: 'flex', m: 2 }}>
      <PropertySelectField<number>
        sx={{ m: 1 }}
        property="Component Thickness"
        options={possibleThicknesses}
        getName={renderNumberInInches}
        value={props.thickness ?? 0}
        submit={props.setFeaturePatternTrussThickness}
      />
    </Box>
  );
}
